/**
 * Seguridad — shell con tabs lineales como rutas hermanas.
 *
 * Sub-rutas:
 *   - /seguridad/usuarios   → Listado y stats por usuario
 *   - /seguridad/roles      → Matriz read-only de permisos por rol
 *   - /seguridad/sesiones   → Sesiones activas + tiempos
 *   - /seguridad/politica   → Configuración de timeout de inactividad
 *
 * Visible para Admin (vista completa) y Operador (Admin-only items hidden vía
 * RBAC en sidebar). Todas las acciones de escritura están auditadas.
 */

import { NavLink, Outlet } from 'react-router-dom';
import { UserCog, Shield, Activity, Clock } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';

const TABS = [
  { to: '/seguridad/usuarios', label: 'Usuarios', icon: UserCog },
  { to: '/seguridad/roles', label: 'Roles y permisos', icon: Shield },
  { to: '/seguridad/sesiones', label: 'Sesiones activas', icon: Activity },
  { to: '/seguridad/politica', label: 'Política de sesión', icon: Clock },
] as const;

export function SeguridadShell() {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-everex-azul">
            <Shield className="h-5 w-5" /> Seguridad
          </CardTitle>
          <p className="text-xs text-gray-600">
            Identidad, autorización y control de sesión. Cumplimiento GAMP 5 / 21 CFR
            Part 11 §11.10(d) — gestión de acceso a sistemas computarizados.
          </p>
        </CardHeader>
        <CardContent>
          <div className="flex flex-wrap gap-2 border-b border-gray-200">
            {TABS.map((t) => (
              <NavLink
                key={t.to}
                to={t.to}
                className={({ isActive }) =>
                  cn(
                    'px-4 py-2 text-sm transition',
                    isActive
                      ? 'border-b-2 border-everex-naranja font-semibold text-everex-azul'
                      : 'text-gray-600 hover:text-everex-azul',
                  )
                }
              >
                <t.icon className="mr-1 inline h-4 w-4" />
                {t.label}
              </NavLink>
            ))}
          </div>
        </CardContent>
      </Card>

      <Outlet />
    </div>
  );
}
